import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { eventApi } from "../api/eventApi";
import { Event } from "../../components/events/types";
import Cookies from "js-cookie";

interface AcademyResponse {
    events?: any;
    is_end?: boolean;
}
export interface AcademyState {
    response: AcademyResponse | undefined;
    page: string;
    dropdown_list: AcademyList[];
}

export type AcademyList = {
    title: string;
    id: string;
    dropdown?: { [key: string]: string }[]; // dropdown is optional
};

const initialState: AcademyState = {
    response: undefined,
    page: "",
    dropdown_list: [],
};

const academySlice = createSlice({
    name: "academy",
    initialState,
    reducers: {
        setPage(state, action: PayloadAction<string>) {
            state.page = action.payload;
        },
        setDropdownList(state, action: PayloadAction<AcademyList[]>) {
            state.dropdown_list = action.payload;
        },
    },
    // extraReducers: (builder) => {
    //     builder.addMatcher(
    //         eventApi.endpoints.getEvents.matchFulfilled,
    //         (state, { payload }: any) => {
    //             state.response = payload.data;
    //         }
    //     );
    // },
});

export const { setPage, setDropdownList } = academySlice.actions;
export default academySlice.reducer;
